import { render, staticRenderFns } from "./MockLocationEdit.vue?vue&type=template&id=65c61261&scoped=true&"
import script from "./MockLocationEdit.vue?vue&type=script&lang=ts&"
export * from "./MockLocationEdit.vue?vue&type=script&lang=ts&"
import style0 from "./MockLocationEdit.vue?vue&type=style&index=0&id=65c61261&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c61261",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VContainer,VRow,VTextField})
